<template>
  <a-modal
    :title="`${modalTit}：${row.excelTitle}`"
    :visible="visible"
    :confirm-loading="confirmLoading"
    width="640px"
    :ok-button-props="{ props: {disabled: !loading && settingList.length !== 0} }"
    wrap-class-name="aggregation-modal"
    :centered="true"
    :mask-closable="false"
    ok-type="primary"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="1"
        :tab="`${setTit}（${settingList.length}）`"
      >
        <span slot="tab">
          {{ $t('message["695"]') }}
          <i
            v-if="!loading && settingList.length"
            class="iconfont iconicon-test34 fs-red"
          />
        </span>

        <div
          v-if="!loading && settingList.length === 0"
          class="prompt-box"
        >
          <img src="@/assets/images/logo-gray.png">
          {{ $t('message["686"]') }}
        </div>
        <aggregation-list
          v-else
          ref="aggregationListRef"
          class="aggregation-list"
          :data="settingList"
          :options="newOptions"
          :row="row"
          @change="handleChange"
        />
      </a-tab-pane>
      <a-tab-pane
        key="2"
        :tab="`${setedTit}（${settedList.length}）`"
        force-render
      >
        <div
          v-if="!loading && settedList.length === 0"
          class="prompt-box"
        >
          <img src="@/assets/images/logo-gray.png">
          {{ $t('message["681"]') }}
        </div>
        <aggregation-list
          v-else
          ref="aggregationListRef"
          class="aggregation-list"
          :data="settedList"
          :options="newOptions"
          :row="row"
          @change="handleChange"
        />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { getAuthTeamInfo } from '@/services/index'
import AggregationList from './AggregationList'

export default {
  components: {
    AggregationList
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      loading: true,
      confirmLoading: false,
      activeKey: '1',
      list: [],
      // cascaderOptions: [],
      newOptions: []
    }
  },

  computed: {
    settingList () {
      return this.list.filter(item => !item.status)
    },
    settedList () {
      return this.list.filter(item => item.status)
    },
    setTit () {
      return this.$t('message["142"]')
    },
    modalTit () {
      return this.$t('message["1019"]')
    },
    setedTit () {
      return this.$t('message["1471"]')
    }
  },

  watch: {
    async visible (val) {
      this.isVisible = val
      if (val) {
        this.activeKey = '1'
        this.getList()

        let { currField = {} } = this.row || {}
        let { fieldtype } = currField

        if (fieldtype === 'select_user') {
          this.newOptions = await this.setCascaderOptions(this.row)
        } else {
          this.newOptions = this.options
        }
      }
    }
  },

  methods: {
    ...mapActions('config/batchImport', ['fetchImportAggregation']),
    hide () {
      this.$emit('update:visible', false)
    },

    async getList () {
      let vm = this
      if (vm.row.aggregationList && vm.row.aggregationList.length) {
        const { fieldtype = '' } = this.row && this.row.currField
        vm.list = vm.row.aggregationList.map(item => {
          let val = null
          if (fieldtype === 'select_user') {
            val = []
            if (vm.$toType(item.fieldvalue) === 'object') {
              for (let k in item.fieldvalue) {
                val.push(item.fieldvalue[k] + '-' + k)
              }
            } else if (item.isignore) {
              val = ['ignore-ignore']
            }
          } else {
            if (item.isignore) {
              val = 'ignore'
            } else {
              val = item.fieldvalue
            }
          }
          return {
            name: item.chartvalue,
            status: !!item.fieldvalue || item.isignore,
            selectVal: val
          }
        })
      } else {
        this.loading = true
        const chain = await this.fetchImportAggregation(this.params)
        chain.onSuccess((payload = {}) => {
          let list = payload.list || []

          vm.list = list.map(item => {
            return {
              name: item,
              status: false,
              selectVal: ''
            }
          })
          vm.loading = false
        })
      }
    },

    //  人员选择下拉 调用接口
    async getData (obj) {
      let { fieldkey = '' } = obj
      let params = {}
      let key = fieldkey && fieldkey.split('_') && fieldkey.split('_')[0]
      if (key === 'follow') {
        key = 'followup'
        params.isspecial = 1
      }
      if (key === 'input') { key = 'add' }

      params.pk = `inquiry-${key}`

      // 是否去除空团队与组
      if (key !== 'followup') {
        params.deal = 1
      }

      const result = await getAuthTeamInfo()
        .params({
          ...params
        }
        ).fetch()

      const { payload: data = [] } = (result && result.data) || {}

      return data
    },
    // 获取人员选择下拉数据，并处理数据
    setCascaderOptions (currRow = {}) {
      return new Promise(async (resolve, reject) => {
        const { fieldkey = '', fieldtype } = currRow.currField || {}
        let loadOptions = await this.getData({ fieldkey })

        if (fieldtype === 'select_user' && loadOptions && loadOptions.length) {
          if (loadOptions[0] && loadOptions[0].name !== ('- ' + this.$t('message["437"]') + '-') && fieldkey !== 'follow_userid') {
            loadOptions.unshift({
              name: `-${this.$t('message["437"]')}-`,
              fieldname: `-${this.$t('message["437"]')}-`,
              id: 'ignore',
              keyname: 'ignore'
            })
          }
          for (let item of loadOptions) {
            item.pId = '0'
          }
          let arr = this.setOptions(loadOptions)
          resolve(arr || [])
        }
      })
    },

    // 处理人员选择的下拉数据
    setOptions (options) {
      for (let i in options) {
        let item = options[i]
        item.label = item.name || item.fieldname
        let value = item.id === undefined ? item.fieldkey : item.id
        item.value = value + '-' + item.keyname
        item.key = item.pId + '-' + item.value
        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let j in item.children) {
            let child = item.children[j]
            child.pId = item.pId + '-' + (item.id || item.fieldkey)
          }
          this.setOptions(item.children)
        }
      }
      return options
    },

    // 获取选择结果
    handleChange (fieldvalue, name) {
      for (let item of this.list) {
        if (item.name === name) {
          item.status = true
          item.selectVal = fieldvalue
        }
      }
    },

    handleOk () {
      this.hide()

      this.$emit('confirm', this.list, this.row)
    },
    handleCancel () {
      this.hide()
      this.$emit('cancel')
    },
    tabCallback (key) {
      this.activeKey = key
    }
  }
}
</script>

<style lang="scss" scoped>
.aggregation-list {
  height: 336px;
  padding-bottom: 40px;
  overflow: scroll;
}
.ant-tabs::v-deep {
  .ant-tabs-bar {
    margin-bottom: 24px;
    padding: 0 24px;
    .ant-tabs-tab {
      padding: 16px 8px;
      margin-right: 16px;
    }
  }
  .ant-tabs-content {
    margin-top: 24px;
  }
}

.prompt-box {
  height: 336px;
  padding: 32px 0;
  color: #b3b3b3;
  text-align: center;
  img {
    display: block;
    width: 24px;
    margin: 0 auto 8px;
  }
}

</style>
<style lang="scss">
.aggregation-modal{
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-footer {
    padding: 12px 24px;
  }
}
</style>
